import { Dropdown } from '@/components/atoms'
import { PageContainer } from '@/components/organisms'
import { ActivitiesSelector } from '@/containers/ClubPlus/CreateTier/phases/Setup/ActivitiesSelector'
import { useFormContext, Controller } from "react-hook-form"

export const Setup = () => {
  const { control } = useFormContext();

  return (
    <section className="mb-80 mt-10">
      <PageContainer>
        <Controller
          name={'content.tierID'}
          control={control}
          render={({ field }) => (
            <Dropdown
              label="Tier Name*"
              placeholder='Choose new tier name'
              isJsonWrap={false}
              childList={[
                {
                  id: 'Bronze',
                  displayText: 'Bronze',
                },
                {
                  id: 'Silver',
                  displayText: 'Silver',
                },
                {
                  id: 'Gold',
                  displayText: 'Gold',
                },
                {
                  id: 'Platinum',
                  displayText: 'Platinum',
                },
              ]}
              updateValue={(value) => {
                const selectedValue = value[0]?.id;
                if (selectedValue) {
                  field.onChange(value[0]?.displayText)
                }
              }}
            />
          )} />
        <div className="my-5 w-full border border-gray-700" />
        <ActivitiesSelector />
      </PageContainer>
    </section>
  )
}
